module.exports = __webpack_public_path__ + "static/PrimitiveTwelve-70e6f9790912dfe8d1a89b04e283541c.png";